import Vuex from 'vuex';
import { shallowMount, createLocalVue } from '@vue/test-utils';
import SubAttachment from './SubAttachment';
import constants from '../../../../../store/modules/constants';

const localVue = createLocalVue();
localVue.use(Vuex);

let attachment = {
  id: 12,
  sub_id: 234,
  name: 'Pro Boost Shine',
  product_id: 15,
  product_type: 'boosts',
  product_type_display_name: 'Treatment',
  qty: 1,
  imagery: {
    standard: {
      mediaId: 6311,
      url: "https://mr-cdn.imgix.net/content/images/2019/4/jvfngtov-pdp-proboost-hydrate-tube-2000x2000/pdp-proboost-hydrate-tube-2000x2000.jpeg?w=350&h=351&fit=crop&crop=faces&auto=format",
      alt_text:"Pro Boost Hydrate Tube"
    }
  }
};

let removeSubAttachmentMock = jest.fn();
let updateSubAttachmentQtyMock = jest.fn();

const store = new Vuex.Store({
  modules: {
    constants,
    subscriptions: {
      namespaced: true,
      actions: {
        removeSubAttachment: removeSubAttachmentMock,
        updateSubAttachmentQty: updateSubAttachmentQtyMock
      }
    }
  }
});

const wrapper = shallowMount(SubAttachment, {
  localVue,
  store,
  propsData: {
    attachment
  }
});

describe('SubAttachment', () => {

  test('general snapshot', () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('methods', () => {

    afterEach(() => {
      removeSubAttachmentMock.mockClear();
      updateSubAttachmentQtyMock.mockClear();
    });

    describe('removeItem', () => {
      test('call removeSubAttachment with expected payload', () => {
        let expectedPayload = {
          sub_id: attachment.sub_id,
          attachment_id: attachment.product_id,
          ctaSource: 'RCD Subscription Management'
        };

        wrapper.vm.removeItem();
        expect(removeSubAttachmentMock).toHaveBeenCalledTimes(1);
        expect(removeSubAttachmentMock).toHaveBeenCalledWith(expect.any(Object), expectedPayload, undefined);
      });
    });

    describe('onQtyChange', () => {
      test('call updateSubAttachmentQty with expected payload', () => {
        let qty = 2;
        let expectedPayload = {
          sub_id: attachment.sub_id,
          attachment_id: attachment.product_id,
          qty,
          ctaSource: 'RCD Subscription Management'
        };

        wrapper.vm.onQtyChange(qty);
        expect(updateSubAttachmentQtyMock).toHaveBeenCalledTimes(1);
        expect(updateSubAttachmentQtyMock).toHaveBeenCalledWith(expect.any(Object), expectedPayload, undefined);
      });
    });

  });

});

